// extracted by css-extract-rspack-plugin
export default {"icon":"XpTBIE0ne00fY2Eu"};